import styled, { css, CSSProp } from "styled-components"
import { Link as GatsbyLink, GatsbyLinkProps } from "gatsby"

import { TextProps, textCss } from "legacy/components/shared/base"

export type LinkProps = GatsbyLinkProps<{}> & TextProps

function animatedUnderlineStyles({
  theme,
  variant = "body",
}: LinkProps): CSSProp {
  if (
    variant === "legal" ||
    variant === "buttonSecondary" ||
    variant === "buttonSecondaryRedesigned"
  ) {
    return css`
      display: inline-block;
      padding: ${variant === "buttonSecondary" ? "0 0 5px" : "0"};
      position: relative;

      &:before {
        @media (max-width: 52em) {
          max-width: none;
        }

        background: ${variant === "legal" ||
        variant === "buttonSecondaryRedesigned"
          ? theme.colors.sky
          : theme.colors.navy};
        bottom: 0;
        content: "";
        display: block;
        height: 1px;
        left: 0;
        max-width: 0;
        padding: 0;
        position: absolute;
        transition: all 150ms ease;
        width: 100%;
      }

      &:hover:before {
        max-width: 100%;
      }
    `
  }

  return css``
}

const Link = styled(GatsbyLink)<LinkProps>`
  ${textCss}
  ${animatedUnderlineStyles}
`

Link.defaultProps = {
  fontFamily: "martel",
  textDecoration: "none",
}

export default Link
